import { render } from "./RedirectCar.vue?vue&type=template&id=0356a0ae"
import script from "./RedirectCar.vue?vue&type=script&lang=js"
export * from "./RedirectCar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__